import { Typography, TypographyProps } from '@mui/material';

import { NONE_TEXT } from '../displayFields/AxleInfoField';

export type NoneLabelProps = { text?: string } & TypographyProps;
export const NoneLabel = ({ text = NONE_TEXT, ...rest }: NoneLabelProps) => {
    return (
        <Typography color='text.disabled' {...rest}>
            {text}
        </Typography>
    );
};
